import React, { useState, useEffect, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import {Col , Form} from "react-bootstrap";
import "components/custom.css";
import { store, persistor } from 'store/index';

const Essay = (props) => {
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(1200);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [content, setContent] = useState('');
  const [lang, setLang] = useState(store.getState().user.lang);
  const [copy, setCopy] = useState('');
  const [resultObj, setResultObj] = useState({});
  const [correctFlag, setCorrectFlag] = useState(true);
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [intervalId, setIntervalId] = useState(null);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  // componentDidMount equivalent
  useEffect(() => {
    console.log("Essay of the Mock test")
    console.log("Here are the porper",props)
    const { isQuestionTime, questionTime, resultMode } = props;

    if (isQuestionTime) {
      setSecondCount(questionTime * 60);
      setShowTimer(isQuestionTime);
    }
    
    if (!resultMode) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      intervalIdRef.current = id;
    }

    // componentWillUnmount equivalent
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      if (recordIdRef.current) {
        clearInterval(recordIdRef.current);
      }
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        const { isQuestionTime, questionTime } = props;
        let secondState = { secondCount: 1200, showTimer: true };
        if (isQuestionTime) {
          secondState = {
            secondCount: questionTime * 60,
            showTimer: isQuestionTime,
          };
        }

        setTimeoutStat(false);
        setCorrectFlag(true);
        setSecondCount(secondState.secondCount);
        setShowTimer(secondState.showTimer);
        setContent('');
        setQuestionId(props.data.id);
        setReset(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setContent("");
        }
      }
    }
  }, [props.data, props.restart, questionId, props.isQuestionTime, props.questionTime]);

  const stopTest = () => {
    props.nextQuestion({ ...resultObj, time: secondCount });
  };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  const cutToClipboard = () => {
    document.execCommand("cut");
  };

  const pasteToClipboard = async () => {
    alert("Press Ctrl+v for paste text");
  };

  const timer = () => {
    setSecondCount((prevCount) => {
      if (prevCount === 1) {
        clearInterval(intervalIdRef.current);
        setTimeoutStat(true);
        if (showTimer) {
          props.nextQuestionHandler();
        }
      }
      return prevCount - 1;
    });
  };

  const cleanString = (input) => {
    let output = "";
    for (let i = 0; i < input.length; i++) {
      output += input.charCodeAt(i) <= 127 ? input.charAt(i) : ' ';
    }
    return output;
  };

  const chaneText = (e) => {
    props.showResult();
    let { name, value } = e.target;
    let clean_value = value.replace('"', '"');
    clean_value = cleanString(clean_value);

    const wordCount = clean_value.split(' ').filter(function(n) { return n != '' }).length;
    const newResultObj = {
      answer: clean_value,
      correct: '',
      length: wordCount,
      time: secondCount,
      lang: lang
    };

    props.submit(newResultObj, true);
    
    setContent(clean_value);
    setResultObj(newResultObj);
  };

  const chaneLang = (e) => {
    setLang(e.target.value);
  };

  const updateCorrect = () => {
    const newResultObj = {
      'answer': '',
      'correct': '',
      'length': 0,
      time: secondCount,
      lang: lang
    };
    props.submit(newResultObj);
    setCorrectFlag(false);
    setResultObj(newResultObj);
  };

  // Handle reset logic
  useEffect(() => {
    if (reset) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      intervalIdRef.current = id;
      setReset(false);
    }
  }, [reset]);

  // Render logic
  let question = "";
  if (props.restart) {
    props.restartQue();
  }
  // Handle stopRecording
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);
  if (props.data) {
    question = props.data.question;
    if (correctFlag) {
      updateCorrect();
    }
  }

  const totalSeconds = Math.max(0, Math.floor(secondCount));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

   function Question({ questionText }) {
   return (
     <div className="write-email" style={{ paddingLeft: "20px" }}>
       {ReactHtmlParser(questionText)}
     </div>
   );
 }

  return (
    <>
      {!props.resultMode &&
        <Col xs={12} className="text-right"><b><p><i className="fa fa-clock-o"></i> 
        {/* <span>Time Left: {Math.floor(secondCount / 60) + ':' + (secondCount % 60)}</span> */}
        <span>Time Left: {minutes}:{seconds.toString().padStart(2, "0")}</span>
        </p> </b></Col>
      }
      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>

      <Col xs={12}>
      <h5 className={props?.testMode ? "para-form" : "reading-text"}>
        {/* {question} */}
       <Question questionText={question} /> 
      </h5>
      </Col>
      <Col xs={12}>
        <div className="col-lg-12 text-center">
          <Col xs={12}>

          </Col>

          {!props.resultMode && !props.answer && <>
            <Col xs={2} style={{ margin: '10px' }}>

            </Col>
            <Col xs={12}>
              <div className="bottomContent test-editor-blue">
                <div className="copyPaste d-flex gap-2 mx-1 py-1">
                  <a href="javascript:void(0)" onClick={cutToClipboard} className="btn">Cut</a>
                  <a href="javascript:void(0)" onClick={copyToClipboard} className="btn">Copy</a>
                  <a href="javascript:void(0)" onClick={pasteToClipboard} className="btn">Paste</a>
                </div>
              </div>
              <Form.Group id="formGroupDiv">
                {!timeoutStat && <Form.Control as="textarea" autoCorrect="false" spellCheck="false" name="content" id="textBox" onChange={(e) => { chaneText(e) }} value={content} />}
                {timeoutStat && <div className="timeout-box">{content}</div>}
              </Form.Group>
              <div className="bottomContent test-editor-blue">
                <div className="copyPaste">
                <p className="wordCount text-white text-start p-2">Word Count: {content.split(' ').filter(function(n) { return n != '' }).length}</p>
                </div>
              </div>
            </Col>

          </>
          }
        </div>
      </Col>
    </>
  );
};

export default Essay;